import { render, staticRenderFns } from "./AdminOverviewInfo.vue?vue&type=template&id=04ab7107&scoped=true&"
import script from "./AdminOverviewInfo.vue?vue&type=script&lang=js&"
export * from "./AdminOverviewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab7107",
  null
  
)

export default component.exports